import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/layout',
      name: 'layout',
      component: () => import('../views/layout'),
      children: [
        {
          path: '/status',
          name: 'status',
          component: () => import('../views/reviewStatus/index')
        },
        {
          path: '/application',
          name: 'application',
          component: () => import('../views/SettleIn/application')
        }
      ]
    },
    {
      path: '/',
      name: 'home',
      component: () => import('../views/home/index')
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('../views/H5/index')
    },
    {
      path: '/RequestToSell',
      name: 'RequestToSell',
      component: () => import('../views/H5/RequestToSell')
    },
    {
      path: '/RegistrationIsComplete',
      name: 'RegistrationIsComplete',
      component: () => import('../views/H5/RegistrationIsComplete')
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js